/** @format */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Link } from "@material-ui/core";
import { TextDecrypt } from "../content/TextDecrypt";
// import ResumePDF from "./../../assets/Yeab_AD_Resume.pdf";
import { ResumeIcon } from "../content/ResumeButton";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getSocialLinks } from "../../action/notesActions";
import { getObject } from "../../utils/getName";

const useStyles = makeStyles((theme) => ({
  footerText: {
    position: "fixed",
    bottom: theme.spacing(6),
    left: theme.spacing(6),
    "&:hover": {
      color: theme.palette.primary.main,
    },
    transition: "all 0.5s ease",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
}));

export const Resume = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const social = useSelector((state) => state.SocialLinks);
  const { socialLinks } = social;

  useEffect(() => {
    // get();
    dispatch(getSocialLinks());
  }, [dispatch]);

  return getObject(socialLinks, "cv")?.status ? (
    <Link
      color="inherit"
      underline="none"
      href={getObject(socialLinks, "cv")?.link}
      // href={`${ResumePDF}`}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.footerText}
    >
      <ResumeIcon />
      <Typography component="span">
        <TextDecrypt text={" Resume"} />
      </Typography>
    </Link>
  ) : (
    <></>
  );
};
